import { addMonths, differenceInMonths, startOfDay } from 'date-fns';

// eslint-disable-next-line import/prefer-default-export
export function computeRemainingMonths(duration?: 0 | 6 | 12 | 24, startDate?: Date): number | undefined {
  if (duration === undefined || duration === 0) return undefined;
  if (startDate === undefined) return undefined;

  const commitmentEndDate = addMonths(startOfDay(startDate), duration);
  const leftoverMonths = differenceInMonths(startOfDay(commitmentEndDate), startOfDay(Date.now())) + 1;
  return leftoverMonths;
}
